import { useTheme } from "@emotion/react";
import {
  Delete,
  Edit,
  ForumOutlined,
  MoreVertOutlined,
  PublicOutlined,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Avatar,
  Button,
  Checkbox,
  Chip,
  Grow,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { alpha, Box } from "@mui/system";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { TransitionGroup } from "react-transition-group";
import api from "../../../services/api";
import apiCliente from "../../../services/apiCliente";
import InternoModalConfirmacaoSaida from "../../modalSaindoDaPagina";
import useStyles from "./styles";
export default function MensagensTicketComponent(params) {
  const {
    ticketDetails,
    isEdit = false,
    itensPublic = [],
    setItensPublic = () => {},
    setTicketDetails = () => {},
    canSendMessage = false,
    isCliente = false,
  } = params;
  const [snackbar, setSnackbar] = useState(null);
  const [selectItens, setSelectItens] = useState({});
  const [isSelect, setIsSelect] = useState(false);
  const [idItensSelect, setIdItensSelect] = useState([]);
  const [objectItens, setObjectItens] = useState({});
  const [selectMensagem, setSelectMensagem] = useState({});
  const [selectEditMensagem, setSelectEditMensagem] = useState({});
  const [newMensagem, setNewMensagem] = useState("");
  const [deleteLoad, setDeleteLoad] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [error, setError] = useState(false);
  const [isEditMensagem, setIsEditMensagem] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const userCliente = JSON.parse(localStorage.getItem("userCliente"));
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;
  const confirmDelete = "Excluir";
  const deleteBody =
    "A mensagem será excluído permanentemente. Deseja excluir a mensagem?";
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSelectMensagem({});
    setSelectEditMensagem({});
  };

  const createItensPublic = async (ticketId, itemType, itensId) => {
    try {
      const response = await api.post("/interno/create/itemPublic", {
        ticketId: ticketId,
        itemType: itemType,
        itensId: itensId,
      });
      setSnackbar({
        children: "Itens publicado para o cliente!",
        severity: "success",
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      setSnackbar({
        children: "Error: Não foi possível publicar itens",
        severity: "error",
      });
    } finally {
    }
  };

  const createMensagem = async (mensagem, ticketId) => {
    try {
      const response = isCliente
        ? await apiCliente.post("/cliente/create/mensagemTicket", {
            mensagem: mensagem,
            ticketId: ticketId,
          })
        : await api.post("/interno/create/mensagemTicket", {
            mensagem: mensagem,
            ticketId: ticketId,
          });

      setSnackbar({
        children: "Mensagem adicionada",
        severity: "success",
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      setSnackbar({
        children: "Error: Não foi possível adicionar mensagem",
        severity: "error",
      });
    } finally {
    }
  };

  const deleteMensagem = async (mensagemId) => {
    try {
      const response = isCliente
        ? await apiCliente.post("/cliente/delete/mensagemTicket", {
            mensagemId: mensagemId,
          })
        : await api.post("/interno/delete/mensagemTicket", {
            mensagemId: mensagemId,
          });

      setSnackbar({
        children: "Mensagem deletada",
        severity: "success",
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      setSnackbar({
        children: "Error: Não foi possível deletar mensagem",
        severity: "error",
      });
    } finally {
    }
  };

  const editMensagem = async (mensagemId, mensagem) => {
    try {
      const response = isCliente
        ? await apiCliente.post("/cliente/edit/mensagemTicket", {
            mensagemId: mensagemId,
            mensagem: mensagem,
          })
        : await api.post("/interno/edit/mensagemTicket", {
            mensagemId: mensagemId,
            mensagem: mensagem,
          });

      setSnackbar({
        children: "Mensagem atualizada",
        severity: "success",
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      setSnackbar({
        children: "Error: Não foi possível atualizar mensagem",
        severity: "error",
      });
    } finally {
    }
  };

  const [loadingCreateMensagem, setLoadingCreateMensagem] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);
  const [selecionados, setSelecionados] = useState(itensPublic?.mensagens);
  const containerRef = useRef(null);
  useEffect(() => {
    resetPublicMensagemClient();
  }, []);
  const resetPublicMensagemClient = () => {
    const result = selecionados?.reduce((acc, curr) => {
      acc[curr] = true;
      return acc;
    }, {});
    setSelectItens(result);
    setIsSelect(false);
  };

  useEffect(() => {
    const idsMensagem = Object.entries(selectItens)?.reduce(
      (acc, [key, value]) => {
        if (value === true) {
          acc[key] = value;
        }
        return acc;
      },
      {},
    );
    setIdItensSelect(Object.keys(idsMensagem));
  }, [selectItens]);

  useEffect(() => {
    if (containerRef.current) {
      // Sempre que mudar a lista, rola para o final
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [ticketDetails?.atendimento_mensagem]);
  const publicMensagemClient = async () => {
    const filtered = Object.entries(selectItens)?.reduce(
      (acc, [key, value]) => {
        if (value === true) {
          acc[key] = value;
        }
        return acc;
      },
      {},
    );
    const arrayItens = Object.keys(filtered);

    try {
      const response = await createItensPublic(
        ticketDetails?.id_atendimento,
        "mensagem",
        arrayItens,
      );
      if (!response) {
        setIdItensSelect(objectItens);
        resetPublicMensagemClient();
        return;
      }
      setSelecionados(arrayItens);
      setItensPublic((prev) => ({ ...prev, mensagens: response }));
    } catch (error) {
      console.error(error);
    } finally {
      setIsSelect(false);
    }
  };

  const createMensagemticket = async () => {
    if (!newMensagem?.trim()) {
      setError(true);
      return;
    }
    setLoadingCreateMensagem(true);
    const response = await createMensagem(
      newMensagem,
      ticketDetails?.id_atendimento,
    );
    if (response?.atendimento_mensagem) {
      const newMensagemObjet = {
        id_atendimento: response?.atendimento_mensagem?.id_atendimento,
        id_atendimento_mensagem:
          response?.atendimento_mensagem?.id_atendimento_mensagem,
        id_usuario: response?.atendimento_mensagem?.id_usuario,
        mensagem: response?.atendimento_mensagem?.mensagem,
        usuario: response?.atendimento_mensagem?.usuario,
        data_cadastro: response?.atendimento_mensagem?.data_cadastro,
      };

      setTicketDetails((prev) => ({
        ...prev,
        atendimento_mensagem: [
          ...(prev.atendimento_mensagem || []), // os existentes depois
          newMensagemObjet,
        ],
      }));
    }

    setNewMensagem("");
    try {
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingCreateMensagem(false);
      setError(false);
    }
  };

  const deletMensagemTicket = async () => {
    try {
      setDeleteLoad(true);
      const response = await deleteMensagem(
        selectMensagem?.id_atendimento_mensagem,
      );

      if (response?.status === "success") {
        const newMensagens = ticketDetails?.atendimento_mensagem?.filter(
          (mensagem) =>
            mensagem?.id_atendimento_mensagem !==
            selectMensagem?.id_atendimento_mensagem,
        );

        setTicketDetails((prev) => ({
          ...prev,
          atendimento_mensagem: newMensagens,
        }));
        const newIdItensSelect = idItensSelect?.filter(
          (item) =>
            item?.toString() !==
            selectMensagem?.id_atendimento_mensagem?.toString(),
        );

        setIdItensSelect(newIdItensSelect);
        setSelectItens((prev) => ({
          ...prev,
          [selectMensagem?.id_atendimento_mensagem]: false,
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDeleteLoad(false);
      handleClose();
      setOpenDeleteModal(false);
    }
  };

  const editMensagemTicket = async () => {
    if (!selectEditMensagem?.mensagem?.trim()) {
      setError(true);
      return;
    }
    setLoadingEdit(true);
    try {
      const response = await editMensagem(
        selectEditMensagem?.id_atendimento_mensagem,
        selectEditMensagem?.mensagem,
      );
      if (response?.status === "success") {
        const newMensagens = ticketDetails?.atendimento_mensagem?.map(
          (mensagem) => {
            if (
              mensagem?.id_atendimento_mensagem ===
              selectEditMensagem?.id_atendimento_mensagem
            ) {
              return selectEditMensagem;
            } else {
              return mensagem;
            }
          },
        );
        setTicketDetails((prev) => ({
          ...prev,
          atendimento_mensagem: newMensagens,
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsEditMensagem(false);
      setSelectEditMensagem({});
      setLoadingEdit(false);
      setError(false);
    }
  };

  // Assumindo que a propriedade 'isCliente' já foi desestruturada no início do seu componente
  // ex: const { ticketDetails, isEdit, isCliente, ... } = params;

  function formatMenssege(objectMessenge) {
    const isChecked =
      selectItens[objectMessenge?.id_atendimento_mensagem] || false;

    // Renomeado para não conflitar com a prop 'isCliente' do componente
    const isClientMessage = objectMessenge?.usuario?.isCliente;

    // Lógica central: A mensagem é "minha" se quem está logado tem o mesmo perfil de quem enviou a mensagem.
    // Usamos '!!' para garantir que undefined/null sejam tratados estritamente como booleans (false)
    const isMyMessage = !!isCliente === !!isClientMessage;

    const handleChange = (event) => {
      // Trava de segurança: impede alteração se a mensagem for do cliente
      if (isClientMessage) return;

      setSelectItens((prev) => ({
        ...prev,
        [objectMessenge?.id_atendimento_mensagem]: event.target.checked,
      }));
    };

    return (
      <Box
        sx={{
          ...styles.containermensagem,
          display: "flex",
          alignItems: "flex-start",
          gap: 1,
          mb: 2,
        }}
      >
        {/* Checkbox fixo à esquerda */}
        {isSelect && (
          <Box sx={{ pt: 1, minWidth: 42 }}>
            {!isClientMessage && ( // Só renderiza se a mensagem NÃO for do cliente
              <Checkbox
                checked={isChecked}
                onChange={handleChange}
                inputProps={{ "aria-label": "controlled" }}
              />
            )}
          </Box>
        )}

        {/* Container de alinhamento direcional */}
        <Box
          sx={{
            display: "flex",
            flex: 1,
            // Alinha na direita se for "minha" mensagem, caso contrário na esquerda
            justifyContent: isMyMessage ? "flex-end" : "flex-start",
          }}
        >
          <Paper
            sx={{
              ...styles.containerPaperMensagem,
              maxWidth: "90%",

              // As cores continuam baseadas em QUEM enviou (para manter a identidade visual)
              backgroundColor: isClientMessage
                ? theme.palette.mode === "dark"
                  ? theme.palette.grey[900]
                  : theme.palette.grey[100]
                : alpha(theme.palette.primary.main, 0.1),

              // O "bico" do balão de chat acompanha o lado que a mensagem está alinhada
              borderTopLeftRadius: isMyMessage ? "16px" : "4px",
              borderTopRightRadius: isMyMessage ? "4px" : "16px",

              border: isClientMessage
                ? `1px solid ${theme.palette.divider}`
                : `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,

              ...(isChecked &&
                isSelect && {
                  outline: `2px solid ${theme.palette.primary.main}`,
                  backgroundColor: alpha(theme.palette.primary.main, 0.15),
                }),
            }}
            elevation={0}
          >
            {/* Cabeçalho da Mensagem */}
            <Box sx={styles.bodyMensagem}>
              <Box sx={styles.containerAvatar}>
                <Avatar
                  sx={{ width: 36, height: 36 }}
                  src={objectMessenge?.usuario?.imagem?.link}
                  alt={objectMessenge?.usuario?.name}
                />
                <Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      sx={{
                        ...styles.nameUser,
                        color: isClientMessage
                          ? "text.primary"
                          : "primary.main",
                      }}
                    >
                      {objectMessenge?.usuario?.name}
                    </Typography>
                    {isClientMessage && (
                      <Chip
                        label="Cliente"
                        size="small"
                        sx={{
                          height: "18px",
                          fontSize: "10px",
                          fontWeight: "bold",
                        }}
                      />
                    )}
                  </Box>
                  <Typography
                    sx={{ fontSize: "11px", color: "text.secondary", mt: 0.5 }}
                  >
                    {dayjs(objectMessenge?.data_cadastro).format(
                      "DD/MM/YYYY HH:mm",
                    )}
                  </Typography>
                </Box>
              </Box>

              {/* Ações / Status à direita do cabeçalho */}
              <Box sx={styles.boxChecked}>
                {isChecked && !isSelect && (
                  <Tooltip title={"Mensagem publicada para o cliente"}>
                    <Chip
                      size="small"
                      label={"Publicado"}
                      sx={styles.chipSelect}
                      icon={
                        <PublicOutlined
                          sx={{
                            ...styles.chipStatusAnexoIcon,
                          }}
                        />
                      }
                    />
                  </Tooltip>
                )}

                {!isSelect &&
                  ((canSendMessage &&
                    userCliente?.usuarioCliente?.id &&
                    objectMessenge?.usuario?.id &&
                    userCliente?.usuarioCliente?.id ===
                      objectMessenge?.usuario?.id) ||
                    (!canSendMessage &&
                      user?.usuario?.id &&
                      objectMessenge?.usuario?.id &&
                      user?.usuario?.id === objectMessenge?.usuario?.id)) && (
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        setIsEditMensagem(false);
                        handleClick(e);
                        setSelectMensagem(objectMessenge);
                        setSelectEditMensagem(objectMessenge);
                      }}
                    >
                      <MoreVertOutlined fontSize="small" />
                    </IconButton>
                  )}
              </Box>
            </Box>

            {/* Corpo da Mensagem */}
            <Box sx={{ padding: "0px 16px 16px 16px" }}>
              {isEditMensagem &&
              selectEditMensagem?.id_atendimento_mensagem ===
                objectMessenge?.id_atendimento_mensagem ? (
                <Box sx={styles.containerEditMensagem}>
                  <TextField
                    value={selectEditMensagem.mensagem}
                    onChange={(e) =>
                      setSelectEditMensagem((prev) => ({
                        ...prev,
                        mensagem: e.target.value,
                      }))
                    }
                    error={error && !selectEditMensagem?.mensagem?.trim()}
                    helperText={
                      error && !selectEditMensagem?.mensagem?.trim()
                        ? "Campo obrigatório"
                        : ""
                    }
                    rows={4}
                    multiline
                    sx={{
                      backgroundColor: theme.palette.background.paper,
                      borderRadius: 1,
                    }}
                  />
                  <Box sx={styles.containerButtons}>
                    <Button
                      size="small"
                      disabled={loadingEdit}
                      onClick={() => {
                        setIsEditMensagem(false);
                        setSelectEditMensagem({});
                      }}
                      variant="outlined"
                    >
                      Cancelar
                    </Button>
                    <LoadingButton
                      loading={loadingEdit}
                      onClick={editMensagemTicket}
                      variant="contained"
                      size="small"
                    >
                      Salvar
                    </LoadingButton>
                  </Box>
                </Box>
              ) : (
                <Typography sx={styles.textMensagem}>
                  {objectMessenge?.mensagem}
                </Typography>
              )}
            </Box>

            {/* Rodapé de Visualizações */}
            {objectMessenge?.visualizadoPor?.length > 0 && (
              <Box
                sx={{
                  ...styles.boxViewed,
                  borderTop: `1px solid ${theme.palette.divider}`,
                }}
              >
                <Typography sx={{ fontSize: "11px", color: "text.secondary" }}>
                  Visualizado por:
                </Typography>
                <Tooltip
                  title={
                    <Box sx={styles.containerTooltip}>
                      {objectMessenge?.visualizadoPor?.map(
                        (userViewed, index) => (
                          <Box key={index} sx={styles.containerName}>
                            <Avatar
                              sx={styles.avatar}
                              src={userViewed?.foto}
                              alt={userViewed?.nome}
                            />
                            <Typography sx={styles.nameUserViewed}>
                              {userViewed?.nome} {userViewed?.sobrenome}
                            </Typography>
                          </Box>
                        ),
                      )}
                    </Box>
                  }
                  arrow
                  placement="top"
                >
                  <Typography
                    sx={{
                      fontSize: "11px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    {objectMessenge?.visualizadoPor?.length} usuário
                    {objectMessenge?.visualizadoPor?.length > 1 ? "s" : ""}
                  </Typography>
                </Tooltip>
              </Box>
            )}
          </Paper>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ height: "80%", overflowY: "auto" }}>
      <>
        <Box sx={styles.boxEdit}>
          <Typography sx={styles.titleDescription}>
            <ForumOutlined sx={{ fontSize: "18px" }} />
            Mensagens
          </Typography>
          {isEdit && !canSendMessage && (
            <>
              {isSelect ? (
                <Box sx={styles.boxIsSelect}>
                  <Button
                    onClick={() => publicMensagemClient()}
                    size="small"
                    variant="contained"
                    /*   disabled={idItensSelect?.length === 0} */
                  >
                    Publicar itens ({idItensSelect?.length})
                  </Button>
                  <Button
                    onClick={() => resetPublicMensagemClient()}
                    size="small"
                    variant="outlined"
                    sx={styles.buttonCancel}
                  >
                    Cancelar
                  </Button>
                </Box>
              ) : (
                <Button
                  onClick={() => setIsSelect(true)}
                  size="small"
                  variant="outlined"
                  sx={styles.buttonCancel}
                >
                  Selecionar itens
                </Button>
              )}
            </>
          )}
        </Box>
        <Box sx={styles.containerBodyModal}>
          <Box ref={containerRef} sx={styles.boxBodyModal}>
            <Paper
              variant="outlined"
              elevation={0}
              sx={styles.containerPaperModal}
            >
              <TransitionGroup style={styles.transitionGrupo}>
                {Array.isArray(ticketDetails?.atendimento_mensagem) &&
                  ticketDetails?.atendimento_mensagem
                    ?.slice()
                    ?.map((menssagem) => (
                      <Grow
                        key={menssagem.id_atendimento_mensagem}
                        timeout={500}
                        style={{ transformOrigin: "top left" }} // anima do topo
                      >
                        <Box sx={{ width: "100%" }}>
                          {formatMenssege(menssagem)}
                        </Box>
                      </Grow>
                    ))}
              </TransitionGroup>
            </Paper>
          </Box>
          {(isEdit || canSendMessage) && erp === "HUBSOFT" && (
            <Paper
              elevation={0}
              sx={{
                ...styles.paperNewMensagem,
              }}
            >
              <Box sx={styles.containerNewMensagem}>
                <TextField
                  disabled={loadingCreateMensagem}
                  placeholder="Nova mensagem"
                  sx={{
                    mt: 1,
                    width: "100%",
                    "& .MuiInputBase-root": {
                      paddingTop: "25px",
                      paddingRight: "5px",
                      paddingBottom: "5px",
                    },
                    "& textarea": {
                      resize: "vertical",
                      minHeight: "80px",
                      padding: "10px 12px",
                    },
                  }}
                  InputProps={{
                    inputComponent: "textarea",
                  }}
                  error={error && !newMensagem?.trim()}
                  helperText={
                    error && !newMensagem?.trim() ? "Campo obrigatório" : ""
                  }
                  value={newMensagem}
                  rows={2}
                  onChange={(e) => setNewMensagem(e.target.value)}
                />

                <Box sx={styles.containerSaveEnviar}>
                  <LoadingButton
                    loading={loadingCreateMensagem}
                    onClick={createMensagemticket}
                    variant="contained"
                    size="small"
                  >
                    Enviar
                  </LoadingButton>
                </Box>
              </Box>
            </Paper>
          )}
        </Box>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          slotProps={{
            list: {
              "aria-labelledby": "basic-button",
            },
          }}
        >
          <MenuItem
            onClick={() => {
              setIsEditMensagem(true);
              setAnchorEl(false);
            }}
          >
            <ListItemIcon>
              <Edit fontSize="small" />
            </ListItemIcon>
            <ListItemText>Editar</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => setOpenDeleteModal(true)}>
            <ListItemIcon>
              <Delete color="error" fontSize="small" />
            </ListItemIcon>
            <ListItemText>Excluir</ListItemText>
          </MenuItem>
        </Menu>
        <InternoModalConfirmacaoSaida
          openConfirmacao={openDeleteModal}
          deleteLoad={deleteLoad}
          setOpenConfirmacao={setOpenDeleteModal}
          execute={() => {
            deletMensagemTicket();
          }}
          title={"Atenção"}
          severity={"error"}
          contentText={deleteBody}
          confirmText={confirmDelete}
        />
        {!!snackbar && (
          <Snackbar
            open
            onClose={() => setSnackbar(null)}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert {...snackbar} onClose={() => setSnackbar(null)} />
          </Snackbar>
        )}
      </>
    </Box>
  );
}
